import api from '@/lib/axios';

export interface AuditLog {
  id: string;
  timestamp: string;
  actor: {
    id: string;
    email: string;
    name?: string;
  };
  action: string;
  target: {
    type: string;
    id?: string;
    name?: string;
  };
  metadata?: Record<string, any>;
  workspace_id: string;
}

export interface AuditLogsResponse {
  logs: AuditLog[];
  total: number;
  limit: number;
  offset: number;
}

export interface AuditLogsFilters {
  action?: string;
  start_date?: string; // ISO date string
  end_date?: string; // ISO date string
  limit?: number;
  offset?: number;
}

/**
 * Fetch audit logs for a workspace
 * 
 * @param workspaceId - The workspace ID
 * @param filters - Optional filters (action, date range, pagination)
 * @returns Audit logs response with pagination info
 */
export async function fetchAuditLogs(
  workspaceId: string,
  filters?: AuditLogsFilters
): Promise<AuditLogsResponse> {
  try {
    const params = new URLSearchParams();
    
    if (filters?.action) {
      params.append('action', filters.action);
    }
    if (filters?.start_date) {
      params.append('start_date', filters.start_date);
    }
    if (filters?.end_date) {
      params.append('end_date', filters.end_date);
    }
    if (filters?.limit) {
      params.append('limit', filters.limit.toString());
    }
    if (filters?.offset) {
      params.append('offset', filters.offset.toString());
    }

    const response = await api.get<AuditLogsResponse>(
      `/workspaces/${workspaceId}/audit-logs?${params.toString()}`
    );
    return response.data;
  } catch (error: any) {
    console.error('[fetchAuditLogs] Error:', error);
    throw new Error(error.response?.data?.message || error.message || 'Failed to fetch audit logs');
  }
}
